<template>
  <div
    class="bg-white border border-slate-200 rounded-2xl p-4 sm:p-5 shadow-sm animate-pulse space-y-3"
    aria-hidden="true"
  >
    <div class="h-3 w-20 bg-slate-100 rounded-full"></div>
    <div class="h-4 w-3/4 bg-slate-200 rounded"></div>
    <div class="h-3 w-1/2 bg-slate-100 rounded"></div>
    <div class="space-y-2">
      <div class="h-3 w-full bg-slate-100 rounded"></div>
      <div class="h-3 w-5/6 bg-slate-100 rounded"></div>
    </div>
    <div class="flex items-center justify-between pt-1">
      <div class="h-3 w-32 bg-slate-100 rounded"></div>
      <div class="h-9 w-24 bg-slate-200 rounded-xl"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OpenSessionCardSkeleton'
};
</script>
